import React, { Component } from 'react'
import {
  Table,
  TableRow,
  TableBody,
  TableFooter,
  TableHeader,
  TableRowColumn,
  TableHeaderColumn
} from 'material-ui/Table'
import Constants from '../../utils/CommonConstants'
const historyFieldLabels = [
  'Agent Name',
  'Status',
  'Performed Time',
  'Reason',
  'Notes'
]
const historyFieldKeys = [
  'agentName',
  'nextStatus',
  'formattedPerformedTime',
  'reasonName',
  'notes'
]

export class HistoryDetails extends Component {
  render() {
    const { caseStatusMap } = this.props
    const caseActions = this.props.caseActions
      .map(action => {
        return {
          ...action,
          formattedPerformedTime: Constants.epochToDateTime(
            action.performedTime
          ),
          nextStatus: caseStatusMap[action.nextStatusId]
        }
      })
      .sort((action1, action2) => action2.performedTime - action1.performedTime)
    const rows = caseActions.map((action, idx) => {
      const cols = historyFieldKeys.map((key, idx) => {
        return (
          <TableRowColumn
            style={{ whiteSpace: 'normal', textAlign: 'center' }}
            key={idx}
          >
            <span
              title={
                ['reasonName', 'nextStatus'].indexOf(key) !== -1
                  ? action[key]
                  : ''
              }
            >
              {action[key]}
            </span>
          </TableRowColumn>
        )
      })
      return <TableRow key={idx}>{cols}</TableRow>
    })
    const thead = historyFieldLabels.map((label, idx) => {
      return (
        <TableHeaderColumn tooltip={label} key={idx}>
          {label}
        </TableHeaderColumn>
      )
    })
    return (
      <Table>
        <TableHeader displaySelectAll={false} enableSelectAll={false}>
          <TableRow selectable={false}>{thead}</TableRow>
        </TableHeader>
        <TableBody showRowHover displayRowCheckbox={false}>
          {rows}
        </TableBody>
      </Table>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/HistoryDetails.js
 **/